// ShortSidebar.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import Tooltip from '../component/Tooltip.jsx';

import { TranslationNamespace } from '../resource/translationNamespace.js';

import media from '../style/media.js';
import { color, breakpoint } from '../style/variables.js';
import ResetButtonStyle from '../style/ResetButtonStyle.js';
import IconArrowUpSource from '../../img/ic_arrow_up.svg';
import IconArrowDownSource from '../../img/ic_dropdown_white.svg';
import { NULL_FUNCTION } from '../resource/defaults.js';

export const ShortSidebar = ({
  t,
  isOnFirst = false,
  isOnLast = false,
  slideNext = NULL_FUNCTION,
  slidePrev = NULL_FUNCTION,
}) => {
  return (
    <StyledShortSidebar>
      <SideBarButton onClick={slidePrev} isOnFirst={isOnFirst}>
        <Tooltip
          position="top"
          renderHint={() => (
            <PrevTooltip>
              {t('previous_content', {
                ns: TranslationNamespace.POST,
              })}
            </PrevTooltip>
          )}
          trigger="hover"
        >
          <SideBarButtonIcon src={IconArrowUpSource} alt="Prev" />
        </Tooltip>
      </SideBarButton>
      <SideBarButton onClick={slideNext} isOnLast={isOnLast}>
        <Tooltip
          position="bottom"
          renderHint={() => (
            <NextTooltip>
              {t('next_content', {
                ns: TranslationNamespace.POST,
              })}
            </NextTooltip>
          )}
          trigger="hover"
        >
          <SideBarButtonIcon src={IconArrowDownSource} alt="next" />
        </Tooltip>
      </SideBarButton>
    </StyledShortSidebar>
  );
};

ShortSidebar.propTypes = {
  t: PropTypes.func.isRequired,
  isOnFirst: PropTypes.bool,
  isOnLast: PropTypes.bool,
  slideNext: PropTypes.func,
  slidePrev: PropTypes.func,
};

const StyledShortSidebar = styled.div`
  position: absolute;
  top: 50%;
  right: -20px;
  width: 40px;
  transform: translate(100%, -50%);
  z-index: 1;
  ${media.mobile`
    display: none;
  `}
`;

const SideBarButton = styled.button`
  ${ResetButtonStyle};
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${color.neutral[20]};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  > div {
    /* Adjust tooltip style */
    width: 28px;
    height: 28px;
  }
  :first-child {
    margin-bottom: 20px;
  }
  ${({ isOnFirst }) => (isOnFirst ? 'visibility: hidden' : '')};
  ${({ isOnLast }) => (isOnLast ? 'visibility: hidden' : '')};

  ${media.mobile`
    display: none;
  `}
  @media (min-width: ${breakpoint.mobile}px) and (max-height: 900px) {
    display: none;
  }
`;

const SideBarButtonIcon = styled.img`
  width: 28px;
  height: 28px;
`;

const TooltipStyle = styled.div`
  min-width: 58px;
  height: 30px;
  padding: 8px;
  border-radius: 8px;
  box-shadow: 0 2px 8px 0 ${color.neutral['0_alpha_50']};
  background-color: ${color.neutral['100_alpha_80']};
  color: ${color.black};
  text-align: center;
  white-space: nowrap;
  font-size: 14px;
`;

const PrevTooltip = styled(TooltipStyle)`
  transform: translate(-25%, -25%);
`;

const NextTooltip = styled(TooltipStyle)`
  transform: translate(-25%, 25%);
`;

export default withTranslation()(ShortSidebar);
